<template>
    <div class="p-col-12">
        <page-header title="dataTable.type-service.title" :actions="pageActions"/>
        <ancestryline-data-table :data-function="dataFunction" :columns="columns" :default-filter="filters" ref="typeservicelistdatatable"/>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import TypeServiceBusiness from "@/business/TypeServiceBusiness";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import DialogService from "@/business/ModalBusiness";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
    import ModalTypeServiceFilter from "@/viewer/type-service/ModalTypeServiceFilter";

    export default {
        name: "TypeServiceList",
        components: {PageHeader, AncestrylineDataTable},

        data() {
            return {
                dataFunction: TypeServiceBusiness.pagination,
                filters: {name: null, isActive: null},
                columns: [
                    {field: "name", header: 'dataTable.type-service.columns.name', sortable:true, style: 'min-width: 300px'},
                    {field: "active", header: 'dataTable.type-service.columns.active', sortable:true, type: 'boolean', style: 'width: 100px'},
                    {field: "typeBilling", header: 'dataTable.type-service.columns.typeBilling', sortable:true, style: 'width: 200px', customFunction: this.typeBillingName},
                    {field: "price", header: 'dataTable.type-service.columns.price', sortable:true, type: 'money', style: 'width: 150px'},
                    {field: "created", header: 'dataTable.type-service.columns.created', sortable:true, type: 'date-time', style: 'width: 200px'},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                          {icon: 'pi pi-pencil', title: 'dataTable.type-service.columns.edit', function: this.editTypeService},
                          {icon: 'pi pi-trash', title: 'dataTable.type-service.columns.delete', function: this.deleteTypeService, refreshList: true},
                        ]
                    },
                ],
                pageActions: [
                    {icon: 'pi pi-filter', label: 'dataTable.protocol.filters', function: this.openFilterModal, type: 'button'},
                    {icon: 'pi pi-tag', label: 'dataTable.type-service.add', url: '/type-service'},
                    /*{icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},*/
                ],
            }
        },

        methods: {

          editTypeService(typeService){
              FrontBusiness.redirect(`/type-service/${typeService.id}`);
          },

          async deleteTypeService(typeService, dataList){
            if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
              const response = await TypeServiceBusiness.delete(typeService.id).catch((e) => {
                if(e.type_service_constraint){
                  ToastMessageBusiness.showError(e.type_service_constraint)
                } else {
                  ToastMessageBusiness.showError(e.message)
                }
              });
              if(response){
                dataList = dataList.filter(c => c.id !== typeService.id);
                ToastMessageBusiness.showSuccess();
              }
              return dataList;
            }
          },

          openModal(){
              //DialogService.openModal(Audit, {business: TypeServiceBusiness});
          },

          typeBillingName: TypeServiceBusiness.typeBillingName,

          async openFilterModal(){
            const filters = await DialogService.openModal(ModalTypeServiceFilter, {filters: this.filters});
            if(filters){
              this.$set(this.$refs.typeservicelistdatatable, 'filters', filters);
              this.$set(this, 'filters', filters);
              await this.$refs.typeservicelistdatatable.loadPage();
            }
          },

        }

    }
</script>

<style scoped>

</style>
